export const toggleModal = "toggleModal"
export const ADD_SUB_CATEGORY_TO_LIST = "ADD_SUB_CATEGORY_TO_LIST"
export const UPDATE_SUB_CATEGORY_IN_LIST = "UPDATE_SUB_CATEGORY_IN_LIST"
export const DELETE_SUB_CATEGORY_FROM_LIST = "DELETE_SUB_CATEGORY_FROM_LIST"
export const ADD_CATEGORIES_TO_LIST = "ADD_CATEGORIES_TO_LIST"
export const ADD_SUB_CATEGORIES_TO_LIST = "ADD_SUB_CATEGORIES_TO_LIST"
